"use client";

import { Link, Outlet, useHref, useLoader } from "@rangojs/router/client";
import { AuthLoader } from "../loaders/auth";
import { FlashBanner } from "./FlashBanner";

export function RootLayout() {
  const href = useHref();
  const user = useLoader(AuthLoader)?.data.user || null;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <nav
          data-testid="nav"
          className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between"
        >
          <Link
            to={href("/")}
            className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent"
          >
            RSC Router
          </Link>
          <div className="flex items-center gap-6">
            {user ? (
              <span className="text-sm text-slate-600">
                Signed in as <span className="font-medium text-slate-900">{user.email}</span>
              </span>
            ) : (
              <Link
                to={href("/login")}
                data-testid="nav-login"
                className="text-slate-600 hover:text-indigo-600 transition-colors font-medium"
              >
                Login
              </Link>
            )}

            <Link
              to={href("/")}
              data-testid="nav-home"
              className="text-slate-600 hover:text-indigo-600 transition-colors font-medium"
            >
              Home
            </Link>
            <Link
              to={href("/about")}
              data-testid="nav-about"
              className="text-slate-600 hover:text-indigo-600 transition-colors font-medium"
            >
              About
            </Link>
            <Link
              to={href("/counter")}
              data-testid="nav-counter"
              className="text-slate-600 hover:text-indigo-600 transition-colors font-medium"
            >
              Counter
            </Link>
            <Link
              to="/shop"
              prefetch="hover"
              data-testid="nav-store"
              className="text-slate-600 hover:text-indigo-600 transition-colors font-medium"
            >
              Store
            </Link>
            <a
              href="https://github.com/ivogt/vite-rsc"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-12">
        <FlashBanner />
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 mt-auto">
        <div className="max-w-5xl mx-auto px-6 py-8 text-center text-slate-500 text-sm">
          <p>
            Built with <span className="text-red-500">♥</span> using React Server Components
          </p>
          <p className="mt-1">Running on Cloudflare Workers</p>
        </div>
      </footer>
    </div>
  );
}
